export const environment = {
  production: true,
  published: false,
  disableSw: false,
  backendUrl: 'https://geoxp-dev.aubertduval.com',
  baseUrl: '/',
  appName: 'GeoXP',
  envName: 'DEV',
  version: '0.0.1',
  auth: {
    tenantId: 'ea0cabda-5ab6-4c4b-8bc3-1fa237655f08',
    clientId: '64459846-6a9a-4548-84af-131abefff15c',
  },
  appInsightsKey: '9af84518-9211-413d-9f88-726316285e95',
  map: {
    center: [1.600870, 43.118585],
    zoom: 19,
    minZoom: 18
  },
}
